module.exports = __webpack_public_path__ + "img/blogr.50bfc47a.svg";